/*
 * @Author: Haoxiwei 1078734933@qq.com
 * @Date: 2023-07-03 09:32:29
 * @LastEditors: Haoxiwei 1078734933@qq.com
 * @LastEditTime: 2023-07-13 11:17:52
 * @FilePath: /WeMeet_admin_project/wemeet-admin/src/api/departmentManagement.js
 * @Description:
 * Copyright (c) 2023 by WeMeet, All Rights Reserved.
 */
import request from '@/utils/request'
/**
 * @description: 部门查询
 * @param {*} params
 * @return {*}
 */
export function getDeptTree(params) {
  return request({
    url: '/iam/dept/listDeptMgmtTree',
    method: 'get',
    params,
  })
}
/**
 * @description: 删除部门
 * @param {*} deptId
 * @return {*}
 */
export function deleteDepartment(deptId) {
  return request({
    url: `/iam/dept/delete/${deptId}`,
    method: 'delete',
  })
}
/**
 * @description: 添加部门
 * @param {*} data
 * @return {*}
 */
export function addDepartment(data) {
  return request({
    url: `/iam/dept/add`,
    method: 'post',
    data,
  })
}

/**
 * @description: 修改部门
 * @param {*} data
 * @return {*}
 */
export function upDateDepartment(data) {
  return request({
    url: `/iam/dept/update`,
    method: 'put',
    data,
  })
}
